import React from 'react';


const UserProfile = (props) => {
	
	const { formValues, user } = props;
	if (formValues && formValues.contact && formValues.contact === "show") {
	  return (
		  <div className="report-contact">
			{user && user.avatar? <div
			  className="avatar-img"
			  style={{ backgroundImage: `url(${user.avatar})` }}
			  alt="avatar"
			/>:null}
  
			<div>
			  <div className="contact-name">
				<h4 className="first-name">
				  {user.firstName}
				</h4>
				<h4 className="last-name">
				{user.lastName}
				</h4>
			  </div>
			  
			</div>
		  </div>
	  );
	}
	return null;
  };
  
  
export default UserProfile;